import AddToBagButton from '../../../components/AddToBagButton';
import React, { MutableRefObject } from 'react';
import styles from './CollarButtonScrollExperiment.module.scss';
import classNames from 'classnames';

interface AddToBagButtonProps {
  disabled?: boolean;
  onAddToBag: () => boolean;
  ctaText?: string;
  hasUpdatedSize?: boolean;
  hasUpdatedSubscriptionSku?: boolean;
  addToCartRef: MutableRefObject<HTMLDivElement | null>;
  scrollToSizeSelection: () => void;
  scrollToMembershipSelection: () => void;
  selectionSummary?: string;
}

export default function CollarButtonScrollExperiment({
  disabled,
  onAddToBag,
  ctaText,
  hasUpdatedSize,
  hasUpdatedSubscriptionSku,
  addToCartRef,
  scrollToSizeSelection,
  scrollToMembershipSelection,
  selectionSummary,
}: AddToBagButtonProps) {
  // user needs to pick size or membership - show scroll button
  const showScrollButton = !hasUpdatedSize || !hasUpdatedSubscriptionSku;
  // user has completed selections - show add to cart button
  const showAddToCartButton = hasUpdatedSize && hasUpdatedSubscriptionSku;

  return (
    <div className={classNames(styles.buttonContainer, styles.action)}>
      {/* Scroll button - shows when user needs to pick size or membership */}
      {showScrollButton && (
        <div className={classNames(styles.jumpButton, styles.visible)}>
          <button
            type="button"
            className={styles.scrollButton}
            onClick={() => {
              if (hasUpdatedSize) {
                scrollToMembershipSelection();
              } else {
                scrollToSizeSelection();
              }
            }}
          >
            {ctaText}
          </button>
        </div>
      )}

      {/* Add to cart button - shows when user has completed size and membership selection */}
      {showAddToCartButton && (
        <div className={classNames(styles.jumpButton, styles.visible)}>
          {selectionSummary && <div className={styles.selectionSummary}>{selectionSummary}</div>}
          <AddToBagButton disabled={disabled} onAddToBag={onAddToBag} ctaText={ctaText} />
        </div>
      )}

      {/* Hidden ref for scroll detection */}
      <div ref={addToCartRef} style={{ height: 0, overflow: 'hidden' }} />
    </div>
  );
}
